module.exports = __webpack_public_path__ + "img/1589.de12f033.gif";